const hobbies = [
  {
    id: 1,
    name: 'tea',
    displayName: '차 🫖',
    score: 0,
    desc: `당신은 새로운 것을 경험할 때 살아있음을 느낍니다. 그런 당신에게 이 세계는 온통 구경하고 맛보고 즐길 것들로 가득한 곳이군요. 여행을 사랑하고 미술관과 극장도 좋아하는 당신에게 마음껏 돌아다니지 못하는 상황은 거의 재앙이나 다름없겠어요. 다소 의외일 수 있겠지만 당신은 차를 제법 좋아할 거예요.
    
차는 다양한 감각을 동원해 즐기는 취미입니다. 향과 맛은 물론 찻잔과 그릇의 아름다운 디자인, 도자기의 촉감까지도 이 취미의 즐거움 중 하나입니다. 홍차와 녹차 모두 나름의 매력이 있어요. 홍차가 귀족 취미라는 건 옛말. 조금만 찾아보면 합리적인 가격의 다구를 쉽게 구할 수 있어요.`,
    link: 'https://coupa.ng/b0dkbg',
  },
  {
    id: 2,
    name: 'wine',
    displayName: '와인 🍷',
    score: 0,
    desc: `현실주의자인 당신. 무언가를 깊이 고민하기보단 경험과 직관에 의존해 일을 처리하는 경향이 있네요. 좋은 게 좋은 거고, 세상 모든 것들이 원만하고 단순하게 흘러갔으면 싶습니다. 그런 태도가 진지하지 않아 보일 때도 있지만, 관대하고 유쾌하며 화끈한 성격 때문에 결과적으로는 당신을 좋은 친구로 생각하는 사람이 많습니다. 그런 당신이 잘 즐길 수 있는 취미는 와인인 것 같네요.
    
와인은 갈수록 대중적인 취미가 되고 있습니다. 생각보다 좋은 와인들이 저렴한 가격에 판매되고 있어요. 치즈나 카나페 같은 간단한 안주를 곁들여 홀짝이는 한 잔은 넷플릭스의 좋은 단짝이죠. 혼술도 좋고, 친한 사람들을 불러 조촐한 홈파티를 해보는 것도 좋을 것 같아요. 술을 잘 못 하는 사람들을 위한 무알콜 와인도 있어요.`,
    link: 'https://coupa.ng/b0dkfC',
  },
  {
    id: 3,
    name: 'gardening',
    displayName: '가드닝 🪴',
    score: 0,
    desc: `당신의 꽃말은 꾸준함입니다. 다른 재능에 비해 많은 주목을 받지 못하지만, 사실 꾸준하게 무언가를 하는 건 결코 쉽지 않은 일입니다. 사람이든 사물이든, 당신 주위의 소중한 존재들을 유지하고 가꾸는 일이 천성에 맞는다면 식물도 잘 기를 수 있을 것 같아요.

꾸준히 성장하는 식물을 보면서 보람도 느끼고 집안도 녹색으로 꾸미는 건 정말 즐거운 경험입니다. 로즈마리나 바질 같은 식용 허브는 수확해서 식탁에 올릴 수도 있어요. 시간을 내는 것이 부담스럽다면 많은 케어 없이도 잘 자라는 다육이부터 시작해봐요.`,
    link: 'https://coupa.ng/b0dkrI',
  },
  {
    id: 4,
    name: 'painting',
    displayName: '그림 그리기 🎨',
    score: 0,
    desc: `당신은 자신만의 확고한 세계와 좋은 취향을 가졌습니다. 영화든 책이든 많은 양은 아니더라도 정말 괜찮은 것들만 볼 줄 아는 감식안이 있네요. 손재주도 괜찮고, 창작을 위해 필요한 고독도 제법 잘 견딜 것 같군요. 좋습니다. 그런 당신의 세계를 그림으로 표현해보면 어떨까요.
    
해본 적이 없어도 괜찮아요. 요즘은 좋은 온라인 클래스도 비교적 싼 가격에 들을 수 있더라구요. 취미로 시작한 그림이 나중엔 귀중한 자산이 될지도 몰라요. 물론 득실을 떠나서 그림 그리는 건 재미있고, 그거면 충분하죠.
    `,
    link: 'https://coupa.ng/b0dku9',
  },
  {
    id: 5,
    name: 'baking',
    displayName: '홈베이킹 🍪',
    score: 0,
    desc: `당신은 평소 많은 주목을 받는 편은 아닙니다. 하지만 당신이 며칠만 사라져도 당신의 챙김을 받던 주변 사람들은 빈 자리를 금세 느낄 거예요. 당신에게 있어 좋은 것을 좋은 사람들과 나누는 것만큼 행복한 일은 없습니다. 이 말에 동의하신다면 당신에게는 홈베이킹이 잘 맞을 것 같아요. 
 
오븐이 있으면 더할 나위 없이 좋겠지만, 오븐 없이 만들 수 있는 디저트도 많아요. 요즘은 저렴한 미니 오븐도 많이 나와 있답니다. 눈과 입을 함께 즐겁게 만드는 디저트로 이 힘든 시기를 잘 넘겨보면 어떨까요.`,
    link: 'https://coupa.ng/b0dkyo',
  },
  {
    id: 6,
    name: 'music',
    displayName: '악기 연주 🎸',
    score: 0,
    desc: `최선을 다해 현재를 즐기면서도 묵묵히 할 일을 해내는 타입. 당신은 한 마디로 베짱이와 개미의 혼종입니다. 항상 놀기만 한다는 오해를 받아서 억울했겠어요. 베짱이도 완벽한 연주를 위해선 연습이 필요한데 말입니다. 당신은 아마 악기를 하나 배우면 금세 실력이 늘 것 같군요.

지금이 딱 시작하기 좋습니다. 기타나 우쿨렐레도 좋고, 요즘은 칼림바도 인기예요. 큰 공간을 차지하지 않는 디지털 피아노도 있어요. 연주 영상을 찍어 주위에 공유하거나 유튜브에 올려보는 것도 재밌겠네요.`,
    link: 'https://coupa.ng/b0dkA6',
  },
  {
    id: 7,
    name: 'boardGame',
    displayName: '보드게임 🎲',
    score: 0,
    desc: `모두를 즐겁게 만드는 유쾌함과 에너지가 넘치는 당신. 분위기 메이커인 동시에 불꽃 같은 승부욕의 화신이기도 하네요. 이미 놀고 있는데도 더 격렬하게 놀고 싶은 당신의 심정을 보통 사람들은 잘 이해하지 못합니다. 그래요. 취미까지 생산적인 걸 할 필요는 없죠. 이번 주말에는 친한 친구나 가족과 함께 보드게임 한 판 어떠신가요?
    
젠가나 할리갈리는 한번쯤 해보셨겠죠. 전략과 지력으로 승부하고 싶다면 스플렌더나 루미큐브, 왁짜지껄한 파티 분위기에는 순발력이 필요한 연상퀴즈 류가 잘 어울려요. 친구들과 모일 때는 항상 개인 방역에 신경 쓰시고요.`,
    link: 'https://coupa.ng/b0dkEP',
  },
  {
    id: 8,
    name: 'vlog',
    displayName: '브이로그 📹',
    score: 0,
    desc: `관종 재질을 타고난 당신. 한편으로는 놀라운 실행력과 집념, 그리고 센스까지 갖췄군요. 이런 타입이 뭘 해도 되는 유형이죠. 트렌드를 놓치는 일이 잘 없고, 단순한 일이라도 당신이 하면 뭔가 다르다는 평가를 받습니다. 이런 멋진 당신의 하루를 영상으로 찍어보면 어떨까요.

꼭 좋은 곳을 가서 찍어야 한다는 고정관념은 접어두고 평범한 일상부터 일기 쓰듯 기록해보세요. 요즘은 스마트폰으로 촬영부터 편집까지 다 해결되는 거 아시죠? 단, 인터넷에 올릴 때는 개인정보나 타인의 초상권에 유의하도록 해요.
    `,
    link: 'https://coupa.ng/b0dkJY',
  },
  {
    id: 9,
    name: 'yoga',
    displayName: '요가 🧘',
    score: 0,
    desc: `건강한 몸에 건강한 정신이 깃드는 법. 당신은 본인을 사랑하고 스스로를 가꾸는 데 관심이 많습니다. 이미 운동을 하나쯤 하고 있을지도 모르겠군요. 열정적이고 스스로를 잘 통제하는 당신의 모습은 주위에 좋은 자극이 되고 있네요. 혹시 집에서 몸과 마음을 단련할 수 있는 요가를 당신의 루틴에 추가하는 건 어떠신가요?
    
오프라인에서 전문 강사에게 배우는 것이 가장 좋겠지만, 많은 분들이 영상이나 온라인 클래스를 통해 요가 수련을 하기도 합니다. 하려는 의지와 요가매트만 있으면 요가러가 될 수 있어요. 당신은 이미 첫번째는 갖추신 것 같네요.`,
    link: 'https://coupa.ng/b0dkNu',
  },
  //   {
  //     id: 9,
  //     name: 'caligraphy',
  //     displayName: '캘리그라피 ✍️',
  //     score: 0,
  //     desc: `'정갈하다'와 '반듯하다'는 당신을 묘사할 때 빼놓을 수 없는 낱말입니다. 주변의 모든 것이 다림질된 옷처럼 정돈되어 있어야 마음이 편해지는 당신은 손재주와 미적 감각도 좋은 편입니다. 그런 당신의 내면을 글씨로 표현해보면 어떨까요.

  // 캘리그라피는 조금 생소하지만, 하면 할수록 다양한 조합으로 시도하며 빠져들 수 있는 취미예요. 책을 읽다가 마음에 드는 문구를 옮겨 적고 사진 찍어서 피드에 올리는 것부터 시작해보세요. 자연스럽게 문구 덕질도 하고, 자신만의 다양한 서체를 개발하다 보면 시간 가는 줄 모를 거예요.
  // `,
  //   },
  {
    id: 10,
    name: 'boxing',
    displayName: '복싱 🥊',
    score: 0,
    desc: `당신은 '아무 것도 안 한다'는 개념을 이해하지 못하는군요. 지루함과 단조로움을 참는 데 쥐약인 당신은 끊임없이 자극과 즐거움을 찾아 다니는 인간 비글입니다. 그 주체할 수 없는 에너지를 좋은 방향으로 쏟아내면 정말 많은 것들을 이룰 수 있을 것 같아요. 도통 나가질 못해 좀이 쑤시는 요즘, 당신에게 딱 어울리는 취미는 복싱입니다.

복싱은 짧은 시간에 많은 열량을 태울 수 있는 좋은 운동입니다. 혼자 하는 운동이니 지루할 거라고 생각한다면 오해입니다. 탭볼을 아시나요? 가성비 최고의 장난감이자 운동기구인 탭볼을 사용해보면 시간 가는 줄 모르고 복싱에 빠진 자신을 발견할 수 있습니다. 10회 연속으로 치는 것부터 도전해봐요.`,
    link: 'https://coupa.ng/b0dkQE',
  },
  {
    id: 11,
    name: 'tarot',
    displayName: '타로카드 🔮',
    score: 0,
    desc: `귀여운 상상력과 호기심이 가득한 당신은 종종 4차원이라는 말을 듣습니다. 사람들은 당신을 마냥 밝은 성격으로 생각하지만 알고보면 당신도 자신만의 문제와 고독하게 싸우고 있지요. 엉뚱한 캐릭터에 가려진 당신의 본모습은 사실 형이상학적인 개념을 능숙하게 다루는 지적인 사람일 가능성이 높습니다. 그러니까 당신은 타로카드의 성좌를 타고났을지도 몰라요.

타로카드는 물론 미신이긴 하지만 나름의 깊이와 재미를 갖춘 지적 유희예요. 카드를 뽑은 결과는 확률의 신이 정하지만, 결과를 어떤 식으로 해석하느냐는 사람의 몫입니다. 상상력과 스토리텔링을 동원해 당신과 친구들의 운명을 점쳐보세요. 카드의 아름다운 디자인을 즐기는 건 덤입니다.`,
    link: 'https://coupa.ng/b0dkUm',
  },
  {
    id: 12,
    name: 'miniature',
    displayName: '모형조립 ✂️',
    score: 0,
    desc: `당신은 한 번 일에 집중하기 시작하면 주변의 소음도 잊고 몰두할 때가 많군요. 소위 '덕후'가 되기 쉬운 외골수 타입이에요. 스스로가 좋아서 하는 일은 종종 믿을 수 없는 성과로 이어집니다. 잠재력으로 충만한 당신에게 창조적 영감과 재미를 동시에 줄 수 있는 취미로 추천하고 싶은 건 모형 조립이에요.

모형이라고 하면 피규어나 건담을 많이 떠올리실 텐데요. 관련 콘텐츠에 관심이 있다면 물론 좋은 선택이지만, 그보다 보편적인 미니어처 하우스라는 선택지가 있습니다. 들어가서 살고 싶을 정도로 예쁜 공간을 내 손으로 직접 만들어가며 느끼는 성취감은 경험해보지 않으면 몰라요. 완성된 작품은 인테리어 소품으로도 손색 없고요.`,
    link: 'https://coupa.ng/b0dkXn',
  },
  {
    id: 13,
    name: 'jewel',
    displayName: '보석십자수 🖼',
    score: 0,
    desc: `당신은 놀라운 집중력과 지구력을 타고난 사람입니다. 보통 사람이라면 진저리를 치고 포기할 일도 기어코 끝장을 보고야 마는 집념이 있네요. 거기다 약간 완벽주의자 기질도 보이는데, 취미로 시작한 일도 죽기 살기로 매달려 작품을 만들어내는 경우가 많아요. 물론 그게 나쁠 건 없죠. 그래서 결론은? 보석십자수를 추천드립니다.
    
아무에게나 추천하지 않는 이 취미는 매우 난이도가 높은 DIY 공예 중 하나입니다. 요령이야 어렵지 않지만, 픽셀 단위로 보석을 붙여 커다란 그림을 만든다는 건 보통 일이 아닙니다. 하지만 그만큼 완성했을 때의 성취감과 완성품의 비주얼은 보장할 수 있어요. 다른 DIY도 그렇지만 라디오나 유튜브는 이 취미의 좋은 단짝이죠.`,
    link: 'https://coupa.ng/b0dk0l',
  },
  {
    id: 14,
    name: 'writing',
    displayName: '글쓰기 📝',
    score: 0,
    desc: `당신의 머릿속에서는 항상 흥미로운 상상과 지적인 물음들이 꼬리에 꼬리를 물고 이어져요. 지식과 논리로 쌓아올린 당신의 내면은 쉽게 무너지거나 침범당하지 않습니다. 이런 타입은 대개 언어능력도 출중한 편이죠. 당신이 글을 쓰는 습관을 들이면 정말 좋을 것 같아요.
    
써볼 수 있는 글은 여러 가지예요. 일기도 괜찮고, 블로그를 운영하거나 브런치 작가, 웹소설 작가에 도전해볼 수도 있겠죠. 꼭 구체적인 목표를 설정하고 그것을 위해 글을 쓰지 않아도, 글을 쓰는 활동 자체가 자존감과 정신 건강을 지키는 데 큰 도움이 된답니다.`,
    link: 'https://coupa.ng/b0eI7B',
  },
  {
    id: 15,
    name: 'comic',
    displayName: '만화 감상 🤣',
    score: 0,
    desc: `번뜩이는 상상력과 아이디어로 무장한 당신은 크리에이티브한 사람입니다. 당신이 지나가듯 툭 던진 말들이 놀라운 해결책의 단서가 되는 일이 많죠. 가끔은 게으름에 빠지거나 심한 감정 기복으로 낭패를 보기도 하지만, 타고난 좋은 머리로 어떻게든 돌파해나가며 살고 있네요. 그래요. 복잡한 세상, 취미라도 편한 걸로 가시죠. 당신에게 어울리는 취미는 만화 감상이에요.
    
좋아하는 간식을 잔뜩 쌓아두고 편한 자세로 누워 좋아하는 만화를 정주행하면 세상에 부러울 게 없을 것 같네요. 웹툰이나 전자책 리더기도 좋지만 종이책만의 대체되지 않는 애틋함이 있어요. 좋아하는 웹툰이 있다면 단행본으로 구해서 감상하는 것도 좋은 방법이죠.`,
    link: 'https://coupa.ng/cbtxJQ',
  },
  {
    id: 16,
    name: 'language',
    displayName: '외국어 공부 🗣',
    score: 0,
    desc: `적극성, 카리스마, 사교적인 성격을 두루 겸비한 당신. 많은 사람들이 당신에게 호감을 느끼고 접근하네요. 사람들을 사귀고 관계를 맺는 데 익숙한 당신에게 언어는 매우 중요한 도구입니다. 당신은 짧은 말, 짧은 메시지라도 어떻게 하면 더 명확하고 기분 좋게 전달될 수 있는지 감각적으로 알고 있네요. 여유시간에 공부를 하는 것에 큰 부담이 없다면 당신에게 외국어 공부를 권하고 싶어요.
    
해외를 돌아다니거나 관련된 일을 하지 않더라도 다른 나라의 언어를 이해한다는 건 일상 속에서 은근히 큰 도움이 됩니다. 이를테면 해당 언어로 된 영화를 보거나 웹 검색을 할 때 요긴하겠죠? 세상을 보는 시야 자체도 넓어지고요. 그리고 누가 알겠어요? 언젠가 국제 연애를 하게 될 지도요.`,
    link: 'https://coupa.ng/b0dlqy',
  },
];

export default hobbies;
